import { useEffect, useState } from 'react';
import { Add, Subtract } from '@styled-icons/remix-fill';

import * as S from './styles';

export type CounterInputProps = {
  min: number;
  max: number;
  amountToIncrement: number;
  initialValue?: number;
  shouldCleanValue?: boolean;
  onChange: (value: number) => void;
  formatter?: (value: number) => string | number;
};

const CounterInput = ({
  min,
  max,
  amountToIncrement,
  initialValue = 0,
  shouldCleanValue = false,
  formatter,
  onChange,
}: CounterInputProps) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (shouldCleanValue && value) {
      setValue(0);
    }
  }, [shouldCleanValue, value]);

  const increment = () =>
    setValue((currentValue) => {
      const newValue = currentValue + amountToIncrement;
      onChange(newValue);
      return newValue;
    });

  const decrement = () =>
    setValue((currentValue) => {
      const newValue = currentValue - amountToIncrement;
      onChange(newValue);
      return newValue;
    });

  return (
    <S.Wrapper>
      <S.Button
        aria-label={`Decrement ${amountToIncrement}`}
        disabled={value - amountToIncrement < min}
        onClick={decrement}
      >
        <Subtract size={24} />
      </S.Button>
      <S.ValueContainer>
        <p>${formatter ? formatter(value) : value}</p>
      </S.ValueContainer>
      <S.Button
        aria-label={`Increment ${amountToIncrement}`}
        disabled={value + amountToIncrement > max}
        onClick={increment}
      >
        <Add size={24} />
      </S.Button>
    </S.Wrapper>
  );
};

export default CounterInput;
